import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import OffersForm from '../components/OffersForm';
import {
  setAccountNumber,
  setSecondAccountNumber,
  setAccountPin,
  setBlockCode,
  submitBlockCode,
  submitRewardsAccount
} from 'routes/DateSelection/reducer';
import {
  accountNumberSelector,
  accountPinSelector,
  blockCodeSelector,
  submittedAccountSelector,
  isAdminSelector,
  submittedBlockCodeSelector,
  activeBlockSelector,
  secondAccountNumberSelector,
  secondSubmittedAccountSelector
} from 'routes/DateSelection/selectors';
import {
  tokenSelector,
  bookingSourceSelector,
  inMobileAppSelector
} from 'routes/selectors';

const mapStateToProps = createStructuredSelector({
  accountNumber: accountNumberSelector,
  accountPin: accountPinSelector,
  submittedAccount: submittedAccountSelector,
  blockCode: blockCodeSelector,
  submittedBlockCode: submittedBlockCodeSelector,
  activeBlock: activeBlockSelector,
  isAdmin: isAdminSelector,
  token: tokenSelector,
  bookingSource: bookingSourceSelector,
  secondAccountNumber: secondAccountNumberSelector,
  secondSubmittedAccount: secondSubmittedAccountSelector,
  inMobileApp: inMobileAppSelector
});

function mapDispatchToProps(dispatch) {
  return {
    setAccountNumber: accountNumber =>
      dispatch(setAccountNumber(accountNumber)),
    setSecondAccountNumber: secondAccountNumber =>
      dispatch(setSecondAccountNumber(secondAccountNumber)),
    setAccountPin: accountPin => dispatch(setAccountPin(accountPin)),
    setBlockCode: blockCode => dispatch(setBlockCode(blockCode)),
    submitBlockCode: () => dispatch(submitBlockCode()),
    submitRewardsAccount: () => dispatch(submitRewardsAccount())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OffersForm);
